var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qrFindError"},[_c('header-top'),_vm._v(" "),_c('div',{staticClass:"error_text"},[_c('img',{attrs:{"src":require("../../image/error1.png"),"alt":"错误"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('qrFindError.deviceError'))+" "),_c('u',{on:{"click":_vm.toPlat}},[_vm._v(_vm._s(_vm.$t('qrFindError.toPlat')))]),_vm._v(" ！")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d32bcd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/m_page/finder/qrFindError.vue
// module id = null
// module chunks = 